import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "prehang-form" }
const _hoisted_2 = {
  key: 0,
  class: "ph-section"
}
const _hoisted_3 = { class: "ph-section-head-container" }
const _hoisted_4 = { class: "ph-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "useContractOptions" }, "Use Contract Options", -1)
const _hoisted_6 = { class: "ph-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Shipment Method", -1)
const _hoisted_8 = { class: "ph-input-group ph-two-col ph-shipment" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ph-shipment-note" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("( "),
    /*#__PURE__*/_createElementVNode("strong", null, "Please Note:"),
    /*#__PURE__*/_createTextVNode(" Crate and Freight Fees for Assembled units are not covered by Prepaid Freight Programs. )")
  ])
], -1)
const _hoisted_10 = { class: "ph-section" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Hinges", -1)
const _hoisted_12 = { class: "ph-input-group" }
const _hoisted_13 = { class: "ph-section" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Latch and Bore", -1)
const _hoisted_15 = { class: "ph-section" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, "Framing", -1)
const _hoisted_17 = { class: "ph-input-group ph-two-col" }
const _hoisted_18 = { class: "ph-section" }
const _hoisted_19 = { class: "ph-section-head-container" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, "Swing - Single", -1)
const _hoisted_21 = { class: "ph-swing-group" }
const _hoisted_22 = { class: "ph-section" }
const _hoisted_23 = { class: "ph-section-head-container" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h4", null, "Swing - Double", -1)
const _hoisted_25 = { class: "ph-input-group ph-two-col" }
const _hoisted_26 = { class: "ph-swing-group" }

import { PreHangSelections } from '@/services/prehang-classes/ph-selections';
    import PreHangSelect from '../inputs/PreHangSelect.vue';
    import { ref, watch, onMounted } from 'vue';
    import { MortisePrepFile, PreHangOption, SwingSelects } from '@/types/preHang';
    import SwingSelect from '../inputs/SwingSelect.vue';
    import SwingInfoModal from '@/components/modals/SwingInfoModal.vue';
    import MortiseFileInput from '../inputs/MortiseFileInput.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreHangForm',
  props: {
        ph: { type: PreHangSelections, required: true }
    },
  emits: ['updatePreHang'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const isSwingInfoOpen = ref<boolean>(false)
    const isSingleSwingInfo = ref<boolean>(true)
    const useContractOptions = ref<boolean>(true)

    watch(useContractOptions, (current) => {
        if(current != props.ph.useContractOptions) {
            props.ph.toggleUseContractOptions()
        }
    })

    function onSelect(option: PreHangOption, field: string) {
        if(field == 'customJambWidth') {
            props.ph?.JambsStops.updateCustomJambWidth(option)
        } else {
            props.ph?.updateSelection(option, field)
        }
        if(props.ph?.selections.swingQuantities?.length > 0 || props.ph?.selections.doubleSwingQuantities?.length > 0) {
            emits('updatePreHang')
        }
    }

    function onUpdateSwing(swings: SwingSelects[], field: string) {
        props.ph?.updateSwingSelection(swings, field)
        emits('updatePreHang')
    }

    function openSwingInfo(isSingle = true) {
        isSingleSwingInfo.value = isSingle
        isSwingInfoOpen.value = true
    }

    function addMortiseFile(file: MortisePrepFile) {
        props.ph.addMortiseFile(file)
    }

    function removeMortiseFile(file: MortisePrepFile) {
        props.ph.removeMortiseFile(file)
    }

    onMounted(() => {
        useContractOptions.value = props.ph.useContractOptions
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (props.ph.isContractDoor)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", null, [
                _withDirectives(_createElementVNode("span", null, "Use Contract Options", 512), [
                  [_vShow, false]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "useContractOptions",
                  class: "form-check-input",
                  "aria-label": "Use Contract Options",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((useContractOptions).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, useContractOptions.value]
                ]),
                _hoisted_5
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(PreHangSelect, {
            fieldName: "shipmentMethod",
            options: props.ph.activeOptions?.shipmentMethod,
            value: props.ph.selections.shipmentMethod || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _hoisted_9
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(PreHangSelect, {
            fieldName: "hingeSize",
            label: "Hinge Size",
            options: props.ph.activeOptions?.hingeSize,
            value: props.ph.selections.hingeSize || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "hingeRadius",
            label: "Hinge Radius",
            options: props.ph.activeOptions?.hingeRadius,
            value: props.ph.selections.hingeRadius || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "hingeFinish",
            label: "Hinge Finish",
            options: props.ph.activeOptions?.hingeFinish,
            value: props.ph.selections.hingeFinish || null,
            onSelect: onSelect,
            "null-value": "Select Hinge Finish",
            "has-required-error": props.ph.errors.includes('hingeFinish')
          }, null, 8, ["options", "value", "has-required-error"])
        ])
      ]),
      _createElementVNode("section", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", {
          class: _normalizeClass(["ph-input-group", {'ph-two-col':props.ph.selections.bore.name == 'Mortise Prep'}])
        }, [
          _createVNode(PreHangSelect, {
            fieldName: "bore",
            label: "Bore",
            options: props.ph.activeOptions?.bore,
            value: props.ph.selections.bore || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "boreBackset",
            label: "Bore Backset",
            "null-value": "",
            onSelect: onSelect,
            options: props.ph.activeOptions?.boreBackset,
            value: props.ph.selections.bore.name == 'None' ? null : props.ph.selections.boreBackset || null,
            "is-disabled": props.ph.selections.bore.name == 'None'
          }, null, 8, ["options", "value", "is-disabled"]),
          (props.ph.selections.bore.name == 'Mortise Prep')
            ? (_openBlock(), _createBlock(MortiseFileInput, {
                key: 0,
                "field-name": "mortisePrepFiles",
                files: props.ph.mortiseFiles,
                onUploadMortiseFile: addMortiseFile,
                onRemoveMortiseFile: removeMortiseFile
              }, null, 8, ["files"]))
            : _createCommentVNode("", true),
          _createVNode(PreHangSelect, {
            fieldName: "latchPrep",
            label: "Latch Prep",
            "null-value": "",
            onSelect: onSelect,
            options: props.ph.selections.bore.name == 'Mortise Prep' ? props.ph.activeOptions?.latchPrep : props.ph.activeOptions?.latchPrep.filter((x) => x.name != 'Mortise Prep'),
            value: props.ph.selections.bore.name == 'None' ? null : props.ph.selections.latchPrep || null,
            "is-disabled": props.ph.selections.bore.name == 'None' || props.ph.selections.bore.name == 'Mortise Prep'
          }, null, 8, ["options", "value", "is-disabled"])
        ], 2)
      ]),
      _createElementVNode("section", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(PreHangSelect, {
            fieldName: "jambMaterial",
            label: "Jamb Material",
            options: props.ph.activeOptions?.jambMaterial,
            value: props.ph.selections.jambMaterial || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "jambType",
            label: "Jamb Type",
            options: props.ph.activeOptions?.jambType,
            value: props.ph.selections.jambType || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "jambWidth",
            label: "Jamb Width",
            options: props.ph.activeOptions?.jambWidth,
            value: props.ph.selections.jambWidth || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "stop",
            label: "Stop",
            options: props.ph.activeOptions?.stop,
            value: props.ph.selections.stop || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          (props.ph.selections.jambWidth.name == 'Custom')
            ? (_openBlock(), _createBlock(PreHangSelect, {
                key: 0,
                fieldName: "customJambWidth",
                label: "Custom Jamb Width",
                options: props.ph.JambsStops?.customJambWidthOptions,
                value: props.ph.JambsStops.customJambWidth || null,
                onSelect: onSelect
              }, null, 8, ["options", "value"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openSwingInfo()))
          }, "View Door Swing Images")
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(SwingSelect, {
            "field-name": "swingQuantities",
            selections: props.ph.selections.swingQuantities || [],
            options: props.ph?.activeOptions?.swing,
            onUpdateSwing: onUpdateSwing
          }, null, 8, ["selections", "options"])
        ])
      ]),
      _createElementVNode("section", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openSwingInfo(false)))
          }, "View Door Swing Images")
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(PreHangSelect, {
            fieldName: "doubleCatches",
            label: "Catches",
            options: props.ph.activeOptions?.doubleCatches,
            value: props.ph.selections.doubleCatches || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "doubleFlushBolt",
            label: "Flush Bolt",
            options: props.ph.activeOptions?.doubleFlushBolt,
            value: props.ph.selections.doubleFlushBolt || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "doubleTAstragal",
            label: "T-Astragal",
            options: props.ph.activeOptions?.doubleTAstragal,
            value: props.ph.selections.doubleTAstragal || null,
            onSelect: onSelect
          }, null, 8, ["options", "value"]),
          _createVNode(PreHangSelect, {
            fieldName: "doubleTAstragalStyle",
            label: "T-Astragal Style",
            options: ((props.ph.selections.doubleTAstragal?.name || '') == 'None') ? props.ph.activeOptions?.doubleTAstragalStyle : props.ph.activeOptions?.doubleTAstragalStyle.filter((x)=> x.name!='None'),
            value: props.ph.selections.doubleTAstragalStyle || null,
            "is-disabled": (props.ph.selections.doubleTAstragal?.name || '') == 'None',
            onSelect: onSelect
          }, null, 8, ["options", "value", "is-disabled"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(SwingSelect, {
            "field-name": "doubleSwingQuantities",
            selections: props.ph.selections.doubleSwingQuantities || [],
            options: props.ph?.activeOptions?.doubleDoorSwing,
            onUpdateSwing: onUpdateSwing
          }, null, 8, ["selections", "options"])
        ])
      ])
    ]),
    _createVNode(SwingInfoModal, {
      modelValue: isSwingInfoOpen.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isSwingInfoOpen).value = $event)),
      "is-single-swing-info": isSingleSwingInfo.value
    }, null, 8, ["modelValue", "is-single-swing-info"])
  ], 64))
}
}

})